export function displayTruncatedText(value, length) {
  if (value && value.length > length) {
    return value.substr(0, length) + '...';
  }
  return value;

}
